import React from "react";
import "../OurStory/KeyExpertise.css";
import { KeyData } from "../OurStory/KeyData";

const Card = ({ title, content, icon }) => {
  return (
    <div className="cards-sea" data-aos="fade-up">
      <div id="icon-container">
        <i id="icon" className={icon}></i>
      </div>
      <div className="user-info">
        <h2 className="card-title">{title}</h2>
        <p className="card-content">{content}</p>
      </div>
    </div>
  );
};

const KeyExpertise = () => {
  return (
    <>
      <div className="key-heading">
        <h3>Key Expertise Areas</h3>
      </div>
      <div className="card-container">
        {KeyData.map((card, index) => (
          <Card
            key={index}
            icon={card.icon}
            title={card.title}
            content={card.content}
          />
        ))}
      </div>
    </>
  );
};

export default KeyExpertise;
